var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"duration-popup"},[_c('PopupHeader',{attrs:{"title":"Długość pobytu","icon":"couple"},on:{"close":_vm.close}}),_vm._v(" "),_c('RadioList',{staticClass:"duration-popup__body",attrs:{"value":_vm.value.range,"options":_vm.value.ranges},on:{"input":_vm.input}}),_vm._v(" "),_c('PopupFooter',{attrs:{"selectAll":"","clear":""},on:{"select":function($event){return _vm.$emit('input', _vm.value)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-148bfbda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/fields/DurationPopup.vue
// module id = 876
// module chunks = 1